"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowUpstreamFlowsQueryGrid = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const FlowsDisplayGrid_1 = require("../sharedDisplayGrid/FlowsDisplayGrid");
function selectConnectionListResult(resultData) {
    const flow = resultData && resultData.flows && resultData.flows[0];
    return flow ? flow.upstreamFlowsConnection : null;
}
function selectConnectionListResultForFilteredQuery(resultData) {
    const flow = resultData && resultData.flows && resultData.flows[0];
    const flowOutputFields = flow && flow.outputFieldsConnection && flow.outputFieldsConnection.nodes;
    const field = flowOutputFields && flowOutputFields[0];
    return field ? field.upstreamFlowsConnection : null;
}
function FlowUpstreamFlowsQueryGrid(props) {
    const emptyGridMessage = catalog_messages_1.Messages.EmptyUpstreamFlowsLineageGridMessage();
    const emptyFilteredGridMessage = catalog_messages_1.Messages.EmptyUpstreamFilteredFlowsLineageGridMessage();
    return (props.filteredFlowOutputFieldId
        ? (
        // Query with Selected Field as Filter
        react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: catalog_queries_1.FlowUpstreamFlowsFilteredByFlowOutputFieldDocument, partialQueryVariables: {
                flowVizportalUrlId: props.flowVizportalUrlId,
                selectedFlowOutputFieldId: props.filteredFlowOutputFieldId,
                orderBy: props.orderBy,
            }, selectConnectionListResult: selectConnectionListResultForFilteredQuery, mapResultNode: FlowsDisplayGrid_1.getRowDataForFlow }, ({ rowStore }) => (react_1.default.createElement(FlowsDisplayGrid_1.FlowsDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyFilteredGridMessage, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }))))
        : (
        // Query without Selection
        react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: catalog_queries_1.FlowUpstreamFlowsDocument, partialQueryVariables: {
                flowVizportalUrlId: props.flowVizportalUrlId,
                orderBy: props.orderBy,
            }, selectConnectionListResult: selectConnectionListResult, mapResultNode: FlowsDisplayGrid_1.getRowDataForFlow }, ({ rowStore }) => (react_1.default.createElement(FlowsDisplayGrid_1.FlowsDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyGridMessage, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder })))));
}
exports.FlowUpstreamFlowsQueryGrid = FlowUpstreamFlowsQueryGrid;
//# sourceMappingURL=FlowUpstreamFlowsQueryGrid.js.map